import { NgModule } from '@angular/core';
import { UrlSerializer } from '@angular/router';

import { CapabilitiesService } from '../shared-context/capabilities.service';
import { CustomUrlSerializer } from './custom-url-serializer.service';
import { OfficeHomeStorageService } from './office-home-storage.service';
import { OneDriveGraphService } from './onedrive-graph.service';
import { OneDriveService } from './onedrive.service';
import { UserDataStorageService } from './user-data-storage.service';
import { VroomService } from './vroom.service';

export function provideOneDriveService(capabilitiesService: CapabilitiesService, oneDriveGraphService: OneDriveGraphService, vroomService: VroomService) {
    const capabilities = capabilitiesService.capabilities;
    return capabilities.useVroomForOneDriveApis ? vroomService : oneDriveGraphService;
}

@NgModule({
    providers: [
        { provide: UrlSerializer, useClass: CustomUrlSerializer },
        { provide: UserDataStorageService, useClass: OfficeHomeStorageService },
        {
            provide: OneDriveService,
            useFactory: provideOneDriveService,
            deps: [CapabilitiesService, OneDriveGraphService, VroomService]
        }
    ]
})
export class BasicServicesModule {
}
